/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.dropdown {
  border-bottom: 1px solid var(--strong-border-color);
  padding: calc(var(--base-spacing) / 2) 0;

  font-family: var(--base-font-family);
  font-size: var(--base-font-size);
  font-weight: var(--medium-font-weight);
}

.dropdown__label {
  color: var(--secondary-text-color);
  margin-right: calc(var(--base-spacing) / 2);
}

.dropdown select {
  position: relative;
  background: none;
  border: none;
  border-radius: 0;
  -webkit-appearance: none;

  padding-right: 25px;
  cursor: pointer;
  z-index: 2;

  font-family: var(--base-font-family);
  font-size: var(--base-font-size);
  font-weight: var(--medium-font-weight);
}

.dropdown__chevron {
  position: absolute;
  top: 5px;
  right: calc(var(--base-spacing) / 4);

  z-index: 1;
}
